import confettiIds from "../constants/confetti.js";
var getConfettiSetId = function getConfettiSetId(name) {
  if (confettiIds[name]) {
    return confettiIds[name];
  }
  throw new Error("Unknown set name: ".concat(name));
};
export default getConfettiSetId;